import { RouteConfig } from 'vue-router';

import Offers from '@/views/club/Offers.vue';

export const offersRoute: RouteConfig = {
  name: 'offers',
  path: 'offers',
  component: Offers,
  meta: { authorized: true }
};
